import React, { useState } from 'react';
import { API_URL } from '../../config';
import * as XLSX from 'xlsx';
import { useSelector, useDispatch } from 'react-redux';
import './UploadMachines.css';
import { insertMachine } from '../general/api'; // Adjust the import path as necessary
import { setData } from '../../actions';

const UploadMachines = ({ handleCloseModal }) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const [file, setFile] = useState(null);
    const [isValidFile, setIsValidFile] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [files, setFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [isXlsx, setIsXlsx] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        if (selectedFile && (selectedFile.name.endsWith('.xlsm') || selectedFile.name.endsWith('.xlsx'))) {
            setIsXlsx(selectedFile.name.endsWith('.xlsx'));
            processFile(selectedFile, (jsonData) => {
                if (validateFile(jsonData)) {
                    setIsValidFile(true);
                    setErrorMessage('');
                } else {
                    setIsValidFile(false);
                    setErrorMessage('El archivo subido no tiene el formato correcto. Asegúrese de que las columnas sean las correctas.');
                }
            });
        } else {
            setIsValidFile(false);
            setErrorMessage('El archivo seleccionado no es de tipo .xlsm o .xlsx.');
        }
    };

    const handleFilesChange = (e) => {
        setFiles([...e.target.files]);
    };

    const validateFile = (jsonData) => {
        if (!jsonData || jsonData.length === 0) {
            return false;
        }

        const requiredHeaders = [
            'Referencia',
            'Ubicación',
            'Nombre',
            'Código Interno',
            'Estado',
            'Fecha de Instalación',
            'Observación',
            'Prioridad',
            'Imagen',
            'Manual pdf'
        ];

        const fileHeaders = Object.keys(jsonData[0]);

        for (let header of requiredHeaders) {
            if (!fileHeaders.includes(header)) {
                alert(`Encabezado faltante o incorrecto: ${header}`);
                return false;
            }
        }
        return true;
    };

    const processFile = (file, callback) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                callback(jsonData);
            } catch (error) {
                setIsValidFile(false);
                setErrorMessage('Error al procesar el archivo. Asegúrese de que el archivo es válido y tiene el formato correcto.');
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400;
        const date_info = new Date(utc_value * 1000);

        const year = date_info.getUTCFullYear();
        const month = ("0" + (date_info.getUTCMonth() + 1)).slice(-2);
        const day = ("0" + date_info.getUTCDate()).slice(-2);

        return `${year}-${month}-${day}`;
    };

    const convertDateFormat = (dateString) => {
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
        const day = ("0" + date.getUTCDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        setIsUploading(true);
        setUploadProgress(0);

        if (isValidFile) {
            processFile(file, async (rows) => {
                let progress = 0;
                const total = rows.length;

                for (const machine of rows) {
                    let formattedDate = '';
                    if (isXlsx) {
                        formattedDate = convertDateFormat(machine['Fecha de Instalación']);
                    } else {
                        formattedDate = excelDateToJSDate(machine['Fecha de Instalación']);
                    }

                    const imageFile = files.find(f => f.name === machine['Imagen']);
                    const pdfFile = files.find(f => f.name === machine['Manual pdf']);

                    try {
                        await insertMachine(user, {
                            ...machine,
                            'Fecha de Instalación': formattedDate
                        }, imageFile, pdfFile);
                        progress++;
                        setUploadProgress((progress / total) * 100);
                    } catch (error) {
                        console.error(error);
                    }
                }

                alert('Máquinas subidas exitosamente');
                setIsUploading(false);
                handleCloseModal();
                dispatch(setData('Maquinas'));
            });
        } else {
            setIsUploading(false);
        }
    };

    return (
        <div className="upload-container">
            <div className="upload-title">
                <h2>SUBIR MÁQUINAS</h2>
            </div>
            <form onSubmit={handleUpload}>
                <label>
                    <strong>Subir archivo Excel: </strong>
                    <input type="file" accept=".xlsm, .xlsx" onChange={handleFileChange} required disabled={isUploading} />
                </label>
                <label>
                    <strong>Seleccionar carpeta de archivos: </strong>
                    <input type="file" accept="*.*" directory="" webkitdirectory="" onChange={handleFilesChange} required disabled={isUploading} />
                </label>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                {isUploading && (
                    <p className="loading-message">Subiendo máquinas, por favor espera...</p>
                )}
                {isUploading && (
                    <div className="progress-bar">
                        <div className="progress" style={{ width: `${uploadProgress}%` }}></div>
                    </div>
                )}
                <div className="button-container">
                    <button onClick={handleCloseModal} disabled={isUploading}>Regresar</button>
                    <button type="submit" disabled={!isValidFile || isUploading}>Subir Máquinas</button>
                </div>
            </form>
            <div className="upload-ref">
                <a href={`${API_URL}/plantillas/plantilla_maquinas.xlsm`} download>
                    Descargar Plantilla
                </a>
            </div>
        </div>
    );
};

export default UploadMachines;
